import moment from 'moment';
import { connect } from 'react-redux';
import { isQAActive } from '../../../../data/filters/questions/isQAActive';
import { isQuestionCategorySubscribable } from '../../../../data/filters/questions/isQuestionCategorySubscribable';
import { isQuestionCategoryVisible } from "../../../../data/filters/questions/isQuestionCategoryVisible";
import { isQuestionCategoryPostable } from '../../../../data/filters/questions/isQuestionCategoryPostable';

export default connect((state, props) => {
    let event = state.events[props.eventId].event,
        now = moment(),
        questions = state.events[props.eventId].questions.listed,
        myUserId = state.session.user.id,
        category,
        categoryProps,
        qcatId = props.qcatId;

    switch (qcatId) {
        case undefined:
        case 'all':
            category = 'all';
            break;
        case 'mine':
            category = 'mine';
            break;
        default:
            category = 'other';
            qcatId = parseInt(props.qcatId);
    }

    // filter questions
    if (category == 'mine') {
        questions = _(questions)
            .filter((q) => {
                return q.asker_id == myUserId || (q.answers && q.answers.mine > 0);
            })
            .value();
    } else if (qcatId && qcatId != 'all') {
        category = _(event.question_categories).find((qcat) => qcat.id == props.qcatId);
        if (category) {
            questions = _(questions)
                .filter((question) => question.category_id == category.id)
                .value();
        }
    } else {
        questions = _(questions)
            .filter((q) => {
                if (!q.category_id) {
                    return true;
                } else {
                    let category = _(event.question_categories).find({
                        id: q.category_id,
                    });
                    if (category) {
                        // VISIBILITY_NEVER = 0
                        return isQuestionCategoryVisible(category) || (category.visibility == 0 && q.asker_id == myUserId);
                    }
                }
            })
            .value();
    }

    // sort filtered questions
    questions = _(questions)
        .sortBy((q) => {
            return -1 * q.lastUpdateTimestamp;
        })
        .value();

    return {
        event,
        questions,
        i18n: state.i18n.translations,
        isQAOpen: event.joined && isQAActive(event),
        //
        category,
        qcatId,
        categories: event.question_categories,
        postableCategories: event.question_categories.filter(isQuestionCategoryPostable),
        subscribableCategories: _(event.question_categories).filter(isQuestionCategorySubscribable).value(),
        notifications: _(state.events[props.eventId].notifications.eventMessage)
            .filter((notif) => _.get(notif, 'content.data.target', '').split('/')[0] == 'questions')
            .reject((notif) => notif.read)
            .value(),
        showTagsOnList: category == 'all' || category == 'mine',
        // attachments
        photoUploadEnabled: category && category.id ? _(category).get('questions_enable_photo_upload', false) : _(event).get('questions_enable_photo_upload', false),
        videoUploadEnabled: category && category.id ? _(category).get('questions_enable_video_upload', false) : _(event).get('questions_enable_video_upload', false),
    };
});
